import { render } from "./DivisionListView.vue?vue&type=template&id=54e53d7d&scoped=true"
import script from "./DivisionListView.vue?vue&type=script&lang=js"
export * from "./DivisionListView.vue?vue&type=script&lang=js"

import "./DivisionListView.vue?vue&type=style&index=0&id=54e53d7d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e53d7d"]])

export default __exports__